import { createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { sendAsync } from "../../../app/applicationSlice";
import { RootThunkApi } from "../../../app/store";
import { PWManagementListParams ,getPWManagementList,getPWManagementExport} from "../../../services/productWithdrawalManagement";

// 列表
export const getPWManagementListAsync = createAsyncThunk<
  void,
  PWManagementListParams,
  RootThunkApi<void>
>('PWManagement/getPWManagementListAsync', async (params, api) => {
  return sendAsync(getPWManagementList(params), api)
})


// 导出
export const getPWManagementExportAsync = createAsyncThunk<void, PWManagementListParams, RootThunkApi<void>>(
  'PWManagement/getPWManagementExportAsync',
  async (params, api) => {
    return sendAsync(getPWManagementExport(params), api)
  }
)
